<div class="profile-wrapper">
	<ng-container *ngIf="isUserLogged; else sign">
		<a href="javascript:void(0)" class="back" (click)="backToStore()">
			<img src="./images/delivery-wallet/maki_arrow.svg" alt="back" loading="lazy">
			<ng-container i18n="@@wallet.back">Back</ng-container>
		</a>

		<div class="profile-content">
			<app-user-info [customer]="customerInfo"></app-user-info>

			<div class="main-area">
				<app-action-cards></app-action-cards>
				<app-order-section></app-order-section>
			</div>
		</div>
	</ng-container>

	<ng-template #sign>
		<app-signin *ngIf="showComponent == 'signin'" (authState)="authToggle($event)"></app-signin>
		<app-signup *ngIf="showComponent == 'signup'" (authState)="authToggle($event)"></app-signup>
		<app-forgot-password *ngIf="showComponent == 'forgot'" (authState)="authToggle($event)"></app-forgot-password>
	</ng-template>
</div>